import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Typography from './Typography';

const Wrapper = styled.div`
  position: fixed;
  z-index: 999;
  top: 0;
  left: 0;
  right: 0;
  height: 40px;
  max-width: 500px;
  display: grid;
  background-color: #359f85;
  color: white;
  margin: auto;
`;

const Sticky = styled.div`
  position: relative;
  z-index: 99;
  display: grid;
  max-width: 500px;
  display: flex;
  align-items: center;
  margin: auto;
  padding-top: 8px;
  padding-bottom: 8px;
  text-align: center;
`;

const StickyInternalMode = () => {
  const [step, setStep] = useState(0);

  const switchStep = (step: number) => {
    switch (step) {
      case 0:
        setTimeout(() => {
          setStep(1);
        }, 10000);
        break;
      case 1:
        setTimeout(() => {
          setStep(2);
        }, 10000);
        break;
      case 2:
        setTimeout(() => {
          setStep(0);
        }, 20000);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    switchStep(step);
  }, [step]);

  return (
    <Wrapper data-testid="topbar-internal-mode">
      <Sticky>
        <Typography variant="100">
          {step === 0 ? (
            <>
              Kamu sedang berada di <b>Mode Internal</b>
            </>
          ) : step === 1 ? (
            <>
              <b>Mode Internal</b>&nbsp;digunakan untuk keperluan lapangan
            </>
          ) : (
            <b>Mode Internal</b>
          )}
        </Typography>
      </Sticky>
    </Wrapper>
  );
};

export default StickyInternalMode;
